// TODO: deprecated — only rendered inside a hidden <div> in EditorApp.jsx
// (kept as legacy reference). Replaced by IdeaTimeline. Safe to delete with
// RemotionTimeline once nothing else depends on it.
import React from "react";
import PropTypes from "prop-types";
import RemotionTimeline from "./RemotionTimeline";

const TimelineSection = ({
  enableTimeline,
  remotionTimelineVisible,
  timelineHeight,
  onToggleVisible,
  onResize,
  onSyncScene,
  i18n,
  remotionTimelineRef,
  boxes,
  store,
  dispatch,
  changeBoxLayer,
  updateBox,
  selectBox,
  updateTextAnimation,
  updateBoxAnimation,
  deleteTextAnimation,
  deleteBoxAnimation,
  saveAnimation,
  onTriggerAnimation,
  onTriggerLayerAnimation,
  onAnimationReset,
  onAnimationUpdate,
  editAnimation,
  playAnimation,
  pauseAnimation,
  setCurrentTime,
  onTextAnimationUpdate,
  onBoxAnimationUpdate,
  onTextAnimationApplied,
  onTextAnimationDeleted,
  onBoxAnimationApplied,
  onBoxAnimationDeleted,
  onKeyframeDelete,
  onAddNewAnimation,
  addAnimation,
  containedViewSelected,
  navItemSelected,
}) => {
  if (enableTimeline === false) return null;

  const handleMouseDown = (e) => {
    if (!remotionTimelineVisible) return;

    const startY = e.clientY;
    const startHeight = timelineHeight;

    const handleMouseMove = (moveEvent) => {
      const deltaY = startY - moveEvent.clientY;
      const newHeight = Math.max(200, Math.min(800, startHeight + deltaY));
      onResize(newHeight);
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    document.body.style.cursor = "ns-resize";
    document.body.style.userSelect = "none";

    e.preventDefault();
    e.stopPropagation();
  };

  const currentScene = store.getState().undoGroup.present.navItemSelected;
  const navItemsById = store.getState().undoGroup.present.navItemsById;
  const soundList = store.getState().undoGroup.present.soundList;
  const pluginToolbars = store.getState().undoGroup.present.pluginToolbarsById;
  const animations = store.getState().undoGroup.present.animationsById;

  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
      }}
    >
      <div
        style={{
          height: "40px",
          background: "#FFFFFF",
          display: "flex",
          alignItems: "center",
          border: "1px solid #D1D5DC",
          padding: "0 16px",
          transition: "all 0.3s ease",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "-3px",
            left: 0,
            right: 0,
            height: "6px",
            cursor: "ns-resize",
            background: "transparent",
            zIndex: 10,
            opacity: remotionTimelineVisible ? 1 : 0,
            pointerEvents: remotionTimelineVisible ? "auto" : "none",
          }}
          onMouseDown={handleMouseDown}
          title="Drag to resize timeline"
        />

        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            cursor: "pointer",
          }}
          onClick={onToggleVisible}
        >
          <button
            style={{
              background: "none",
              border: "none",
              color: "#364153",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "14px",
              cursor: "pointer",
              letterSpacing: "0.5px",
            }}
            title={remotionTimelineVisible ? "Collapse Timeline" : "Expand Timeline"}
          >
            <i
              className="material-icons"
              style={{
                fontSize: "20px",
                transition: "transform 0.3s ease",
                transform: remotionTimelineVisible ? "rotate(0deg)" : "rotate(-90deg)",
              }}
            >
              keyboard_arrow_down
            </i>
            Timeline
          </button>

          <button
            className="sync-scene-btn"
            onClick={(e) => {
              e.stopPropagation();
              onSyncScene();
            }}
            title={i18n.t("messages.syncScene.buttonTitle")}
          >
            <i className="material-icons">sync</i>
            {i18n.t("messages.syncScene.buttonLabel")}
          </button>
        </div>
      </div>

      <div
        style={{
          bottom: 0,
          left: 0,
          right: 0,
          height: remotionTimelineVisible ? `${timelineHeight}px` : "0px",
          overflow: "hidden",
          transition: "height 0.3s ease",
          background: "#ffffff",
          zIndex: 1000,
          borderTop: remotionTimelineVisible ? "1px solid #e5e7eb" : "none",
          boxShadow: remotionTimelineVisible ? "0 -4px 12px rgba(0, 0, 0, 0.15)" : "none",
        }}
      >
        {remotionTimelineVisible && (
          <div style={{ width: "100%", height: "100%" }}>
            <RemotionTimeline
              ref={remotionTimelineRef}
              visible={remotionTimelineVisible}
              showPlayer={true}
              boxes={boxes}
              currentScene={currentScene}
              navItemsById={navItemsById}
              soundList={soundList}
              pluginToolbars={pluginToolbars}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "0",
                border: "none",
                margin: "0",
                padding: "0",
              }}
              animations={animations}
              onLayerSelect={(layerId, isSelected) => {
                if (isSelected) {
                  dispatch(selectBox(layerId));
                }
              }}
              onLayerReorder={(layerId, newIndex) => {
                const box = boxes[layerId];
                if (box) {
                  const parent = box.parent;
                  const container = box.container || null;
                  const allBoxes = Object.values(boxes).filter((b) => !b.id?.includes("_"));
                  dispatch(changeBoxLayer(layerId, parent, container, newIndex, allBoxes));
                }
              }}
              onLayerVisibilityToggle={(layerId, visible) => {
                const box = boxes[layerId];
                if (box) {
                  const updatedBox = { ...box, visible: visible };
                  dispatch(updateBox(layerId, updatedBox));
                }
              }}
              onUpdateBoxVisibility={(layerId, visible) => {
                const box = boxes[layerId];
                if (box) {
                  const updatedBox = { ...box, visible: visible };
                  dispatch(updateBox(layerId, updatedBox));
                }
              }}
              onAnimationDurationChange={(layerId, startTime, endTime) => {
                const animationsByLayer =
                  store.getState().undoGroup.present.animationsById[layerId] || [];
                if (animationsByLayer.length > 0) {
                  animationsByLayer.forEach((animation, index) => {
                    let newDuration = animation.duration;

                    if (index === 0) {
                      newDuration = startTime;
                    } else if (index === animationsByLayer.length - 1) {
                      newDuration = endTime;
                    } else {
                      const progress = index / (animationsByLayer.length - 1);
                      newDuration = startTime + (endTime - startTime) * progress;
                    }

                    if (animation.type === "text") {
                      dispatch(
                        updateTextAnimation(
                          layerId,
                          animation.animation,
                          newDuration,
                          animation.delay || 0
                        )
                      );
                    } else {
                      dispatch(
                        updateBoxAnimation(
                          layerId,
                          animation.animation,
                          newDuration,
                          animation.delay || 0
                        )
                      );
                    }
                  });
                }
              }}
              onSaveNewAnimation={(id, animationsList) =>
                dispatch(saveAnimation(id, animationsList))
              }
              onTriggerAnimation={onTriggerAnimation}
              onTriggerLayerAnimation={onTriggerLayerAnimation}
              onAnimationReset={onAnimationReset}
              onAnimationUpdate={onAnimationUpdate}
              editAnimation={editAnimation}
              playAnimation={playAnimation}
              pauseAnimation={pauseAnimation}
              setCurrentTime={setCurrentTime}
              onTextAnimationUpdate={onTextAnimationUpdate}
              onBoxAnimationUpdate={onBoxAnimationUpdate}
              onTextAnimationApplied={onTextAnimationApplied}
              onTextAnimationDeleted={onTextAnimationDeleted}
              onBoxAnimationApplied={onBoxAnimationApplied}
              onBoxAnimationDeleted={onBoxAnimationDeleted}
              onKeyframeDelete={onKeyframeDelete}
              onAddNewAnimation={(id, positionx, positiony, width, height, duration) =>
                dispatch(
                  addAnimation(id, {
                    positionx,
                    positiony,
                    width,
                    height,
                    duration,
                  })
                )
              }
              containedViewSelected={containedViewSelected}
              navItemSelected={navItemSelected}
            />
          </div>
        )}
      </div>
    </div>
  );
};

TimelineSection.propTypes = {
  enableTimeline: PropTypes.any,
  remotionTimelineVisible: PropTypes.bool.isRequired,
  timelineHeight: PropTypes.number.isRequired,
  onToggleVisible: PropTypes.func.isRequired,
  onResize: PropTypes.func.isRequired,
  onSyncScene: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  remotionTimelineRef: PropTypes.any,
  boxes: PropTypes.object.isRequired,
  store: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  changeBoxLayer: PropTypes.func.isRequired,
  updateBox: PropTypes.func.isRequired,
  selectBox: PropTypes.func.isRequired,
  updateTextAnimation: PropTypes.func.isRequired,
  updateBoxAnimation: PropTypes.func.isRequired,
  deleteTextAnimation: PropTypes.func.isRequired,
  deleteBoxAnimation: PropTypes.func.isRequired,
  saveAnimation: PropTypes.func.isRequired,
  onTriggerAnimation: PropTypes.func.isRequired,
  onTriggerLayerAnimation: PropTypes.func.isRequired,
  onAnimationReset: PropTypes.func.isRequired,
  onAnimationUpdate: PropTypes.func.isRequired,
  editAnimation: PropTypes.func.isRequired,
  playAnimation: PropTypes.func.isRequired,
  pauseAnimation: PropTypes.func.isRequired,
  setCurrentTime: PropTypes.func.isRequired,
  onTextAnimationUpdate: PropTypes.func.isRequired,
  onBoxAnimationUpdate: PropTypes.func.isRequired,
  onTextAnimationApplied: PropTypes.func.isRequired,
  onTextAnimationDeleted: PropTypes.func.isRequired,
  onBoxAnimationApplied: PropTypes.func.isRequired,
  onBoxAnimationDeleted: PropTypes.func.isRequired,
  onKeyframeDelete: PropTypes.func.isRequired,
  onAddNewAnimation: PropTypes.func.isRequired,
  addAnimation: PropTypes.func.isRequired,
  containedViewSelected: PropTypes.any,
  navItemSelected: PropTypes.any,
};

export default TimelineSection;
